import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import React from 'react';

import { CloseIcon } from '../../icons';

const StyledIconButton = styled(IconButton)({
  '& .MuiTouchRipple-child': {
    backgroundColor: `#f6f8fa !important`,
  },
});

interface CloseButtonProps extends IconButtonProps {
  iconSize?: number;
}

export const CloseButton = ({ iconSize = 20, ...props }: CloseButtonProps) => {
  return (
    <StyledIconButton
      aria-label="close"
      color="primary"
      sx={{
        width: iconSize * 2,
        height: iconSize * 2,
      }}
      {...props}
    >
      <CloseIcon
        sx={{
          fontSize: iconSize,
        }}
      />
    </StyledIconButton>
  );
};
